import ApiService from "@/core/services/api.service";
import { SET_PAGE_LOADING } from "@/core/services/store/config.module";

// action types
export const UPDATE_TABLE_STRUCTURE =
  "getORDERDELIVERYCONFIRMATIONTableStructure";
export const UPDATE_TABLE_DATA = "updateORDERDELIVERYCONFIRMATIONTableData";
export const EXPORT_TABLE_DATA = "exportORDERDELIVERYCONFIRMATIONTableData";

// mutation types
export const SET_TABLE_STRUCTURE = "setORDERDELIVERYCONFIRMATIONTableStructure";
export const SET_TABLE_DATA = "setORDERDELIVERYCONFIRMATIONTableData";
export const SET_TABLE_FILTER = "setORDERDELIVERYCONFIRMATIONTableFilter";
export const SET_TABLE_PAGE = "setORDERDELIVERYCONFIRMATIONTablePage";
export const SET_TABLE_PERPAGE = "setORDERDELIVERYCONFIRMATIONTablePerPage";
export const SET_TABLE_SORTBY = "setORDERDELIVERYCONFIRMATIONTableSortBy";
export const SET_TABLE_SORTORDER = "setORDERDELIVERYCONFIRMATIONTableSortOrder";
export const SET_EXPORT_LINK = "setORDERDELIVERYCONFIRMATIONExportLink";
export const SET_SCANNED_ITEMS = "setORDERDELIVERYCONFIRMATIONScannedItems";

const state = {
  export_link: null,
  table_structure: {},
  table_data: {},
  table_state: {
    page: 1,
    per_page: 50,
    sortBy: "id",
    sortOrder: "desc",
    filters: [],
  },
  scanned_items: [],
};

const getters = {
  /**
   * for table title, description
   * */
  getORDERDELIVERYCONFIRMATIONTableProperties(state) {
    return state.table_structure.properties;
  },
  /**
   * for table permissions
   **/
  getORDERDELIVERYCONFIRMATIONTablePermissions(state) {
    return state.table_structure.permissions;
  },
  getORDERDELIVERYCONFIRMATIONTableState(state) {
    return state.table_state;
  },

  getORDERDELIVERYCONFIRMATIONTableHeaders(state) {
    return state.table_structure.columns;
  },

  getORDERDELIVERYCONFIRMATIONTableFilters(state) {
    return state.table_structure.filters;
  },

  getORDERDELIVERYCONFIRMATIONTableData(state) {
    return state.table_data.data;
  },

  getORDERDELIVERYCONFIRMATIONExportUrl(state) {
    return state.export_link;
  },
  getORDERDELIVERYCONFIRMATIONScannedItems(state) {
    return state.scanned_items;
  },
};

const actions = {
  [UPDATE_TABLE_STRUCTURE](context) {
    return new Promise((resolve) => {
      ApiService.post(
        "/warehouse_management/custom/standard_order_delivery_confirmations"
      )
        .then(({ data }) => {
          context.commit(SET_TABLE_STRUCTURE, data);
          context.commit(SET_PAGE_LOADING, false);
          resolve(data);
        })
        .catch((data) => {
          context.commit(SET_PAGE_LOADING, false);
          resolve(data);
        });
    });
  },
  [UPDATE_TABLE_DATA](context, payload) {
    context.commit(SET_PAGE_LOADING, true);
    return new Promise((resolve) => {
      ApiService.post(
        "/warehouse_management/custom/standard_order_delivery_confirmations/datatable",
        payload
      )
        .then(({ data }) => {
          context.commit(SET_TABLE_DATA, data);
          resolve(data);
          context.commit(SET_PAGE_LOADING, false);
          setTimeout(() => {
            window.scrollTo(0, 0);
          }, 100);
        })
        .catch((data) => {
          context.commit(SET_PAGE_LOADING, false);
          resolve(data);
        });
    });
  },
  [EXPORT_TABLE_DATA](context, payload) {
    context.commit(SET_PAGE_LOADING, true);
    return new Promise((resolve) => {
      ApiService.post(
        "/warehouse_management/custom/standard_order_delivery_confirmations/export",
        payload
      )
        .then(({ data }) => {
          context.commit(SET_EXPORT_LINK, data.url);
          resolve(data);
        })
        .catch((data) => {
          context.commit(SET_PAGE_LOADING, false);
          resolve(data);
        });
    });
  },
};

const mutations = {
  [SET_SCANNED_ITEMS](state, scanned_items) {
    if (Array.isArray(scanned_items)) {
      state.scanned_items = [];
    } else state.scanned_items.push(scanned_items);
  },
  [SET_TABLE_FILTER](state, filter) {
    state.table_state.filters = filter;
  },
  [SET_TABLE_PAGE](state, page) {
    state.table_state.page = page;
  },
  [SET_TABLE_PERPAGE](state, perPage) {
    state.table_state.per_page = perPage;
  },
  [SET_TABLE_SORTBY](state, sortBy) {
    state.table_state.sortBy = sortBy;
  },
  [SET_TABLE_SORTORDER](state, sortOrder) {
    state.table_state.sortOrder = sortOrder;
  },
  [SET_TABLE_STRUCTURE](state, table_structure) {
    state.table_structure = table_structure.data;
  },
  [SET_TABLE_DATA](state, table_data) {
    state.table_data = table_data;
  },
  [SET_EXPORT_LINK](state, link) {
    state.export_link = link;
  },
};

export default {
  state,
  actions,
  mutations,
  getters,
};
